import appHelper from './app/helper'
import componentsHelper from './components/helper'
import draggableHelper from './draggable/helper'
import settingsHelper from './settings/helper'

const StoreHelper = {
  ...appHelper,
  ...componentsHelper,
  ...draggableHelper,
  ...settingsHelper
}

export default StoreHelper
